import React from 'react';
import tShirt from 'assets/t-shirt.png';
import voucher from 'assets/voucher.png';

const Rewards = (): JSX.Element => {
	const data = [
		{
			id: 1,
			img: tShirt,
			title: 'T-shirt',
			price: 25,
		},
		{
			id: 2,
			img: voucher,
			title: 'Voucher',
			price: 15,
		},
	];

	return (
		<div className="rewards">
			<h2 className="title">Your points: <strong>50</strong></h2>

			{data.map(({ id, img, price, title }) => (
				<div key={id} className="reward-card">
					<img src={img} alt="reward" className="reward-image"/>
					<div className="reward-wrapper">
						<h3 className="reward-title">{title}</h3>
						<p className="reward-price">Price: <strong>{price}</strong></p>
						<button className="button button-blue">Buy</button>
					</div>
				</div>
			))}
		</div>
	);
};

export default Rewards;
